import { colors } from '../../colors';
var address = {
  addressColor: colors.lead
};
export default address;